
export const fullNameValidator = (data) => {
    const onlyLetters = /^[A-Za-z\s]+$/;

    if (!data.trim()) {
        return "Full Name is required";
    }
    else if (data.length < 3) {
        return "Full Name must be at least 3 characters";
    }
    else if (!onlyLetters.test(data)) {
        return "Full Name should contain only letters and spaces";
    }

    return null;
};


export const firstNameValidator = (data) => {
    if (!data.trim())
        return ("First Name is required")
    else if (data.length < 3)
        return ('First Name must be atleast 3 characters')

    return (null)
}

export const lastNameValidator = (data) => {
    if (data && !/^[A-Za-z]*$/.test(data))
        return ('Last Name must be atleast 1 character')

    return (null)
}

export const middleNameValidator = (data) => {
    if (data && !/^[A-Za-z ]*$/.test(data))
        return ('Middle Name must  characters')

    return (null)
}

export const emailValidator = (inputEmail) => {
    const emailErrors = [];

    if (!inputEmail || !inputEmail.trim()) {
        emailErrors.push("Email is required.");
    } else {
        // Updated regex: At least 2 characters before @, 2 after @, 2 after last dot
        const emailRegex = /^[^\s@]{2,}@[^\s@]{2,}\.[^\s@]{2,}$/;
        if (!emailRegex.test(inputEmail)) {
            emailErrors.push("Enter a valid email address (minimum 2 characters before and after '@' and '.' required).");
        }
    }

    return emailErrors.join(" ");
};

export const contactValidator = (data) => {
    if (!data)
        return "Contact is required";
    else if (!/^[6-9]\d{9}$/.test(data))
        return "Contact number must be 10 digits and start with 6–9";

    return null;
}

export const ticketIssueValidator = (data) => {
    if (!data.trim())
        return ("Issue is required")
    else if (data.length < 10)
        return ('Minimum 10 characters ')

    return (null)
}

export const URL = (data) => {
    const value = data.trim();
    const urlRegex = /^https?:\/\/.+\..+/i;
    if (!value) {
        return "URL is required";
    } else if (!urlRegex.test(value)) {

        return "Enter a valid URL (must start with http:// or https://)";
    }
    else {
        return null;
    }

};



export const passwordValidator = (inputPassword) => {
    const passwordRegex = {
        length: /.{8,}/,
        upper: /[A-Z]/,
        lower: /[a-z]/,
        number: /[0-9]/,
        special: /[@$!%*#?&.]/,
    };
    const passErrors = [];

    if (!inputPassword || !inputPassword.trim()) {
        passErrors.push("Password is required.");
    } else {
        if (!passwordRegex.length.test(inputPassword)) {
            passErrors.push("Minimum 8 characters.");
        }
        if (!passwordRegex.upper.test(inputPassword)) {
            passErrors.push("At least 1 uppercase letter.");
        }
        if (!passwordRegex.lower.test(inputPassword)) {
            passErrors.push("At least 1 lowercase letter.");
        }
        if (!passwordRegex.number.test(inputPassword)) {
            passErrors.push("At least 1 number.");
        }
        if (!passwordRegex.special.test(inputPassword)) {
            passErrors.push("At least 1 special character (@$!%*#?&.).");
        }
    }
    return passErrors.join(" ");
};


export const confirmPasswordValidator = (data, password) => {
    if (!data.trim())
        return ("Confirm Password is required")
    else if (data.length < 8)
        return ('Password must be ≥8 characters ')
    else if (password !== data)
        return ('Password do not match')
    return (null)
}
export const languageValidator = (lang) => {
    const nameErr = lang?.name ? null : "Language is required";
    const proficiencyErr = lang?.proficiency
        ? null
        : "Fluency level is required";
    return { nameErr, proficiencyErr };
};



// Address form validation
export const validateAddressForm = (values) => {
    const patterns = {
        doorNumber: {
            regex: /^[0-9A-Za-z\-/]{1,10}$/,
            message: "Door number can only have letters, numbers, - or / (max 10 chars)."
        },
        addressLine1: {
            regex: /^[A-Za-z0-9\s,.-]{0,100}$/,
            message: "Address Line 2 can be empty or up to 100 characters (letters, numbers, space, , . - allowed)."
        },
        zipCode: {
            regex: /^[0-9]{5,6}$/,
            message: "Zip Code must be 5 or 6 digits."
        },
        state: {
            regex: /^[A-Za-z\s]{2,50}$/,
            message: "State must contain only letters and spaces (2–50 chars)."
        },
        country: {
            regex: /^[A-Za-z\s]{2,50}$/,
            message: "Country must contain only letters and spaces (2–50 chars)."
        }
    };

    let errors = {};

    Object.keys(patterns).forEach((field) => {
        const { regex, message } = patterns[field];
        const value = values[field];

        if (!value || !regex.test(value)) {
            errors[field] = message;
        }
    });

    return errors;
}



// ✅ Preferred Job Info validation
export function validatePreferredJobForm(values) {
    const errors = {};

    // 1. Array fields - at least 1 value select panna vendum
    if (!Array.isArray(values.preferredJobRole) || values.preferredJobRole.length === 0) {
        errors.preferredJobRole = "Select at least one job role.";
    }

    if (!Array.isArray(values.preferredJobLocations) || values.preferredJobLocations.length === 0) {
        errors.preferredJobLocations = "Select at least one job location.";
    }

    if (!Array.isArray(values.employmentType) || values.employmentType.length === 0) {
        errors.employmentType = "Select at least one employment type.";
    }

    if (!Array.isArray(values.preferredWorkMode) || values.preferredWorkMode.length === 0) {
        errors.preferredWorkMode = "Select at least one work mode.";
    }

    // 2. CTC Validation (current & expected → only numbers allowed, optional LPA)
    const ctcRegex = /^[0-9]+(\.[0-9]{1,2})?$/; // 10 or 10.5 etc.
    if (!values.currentCTC || !ctcRegex.test(values.currentCTC)) {
        errors.currentCTC = "Enter a valid Current CTC (numbers only, e.g., 5 or 5.5).";
    }

    if (!values.expectedCTC || !ctcRegex.test(values.expectedCTC)) {
        errors.expectedCTC = "Enter a valid Expected CTC (numbers only, e.g., 10 or 10.5).";
    }

    // 3. Notice period (accepts only numbers in days or months)

    if (!values.noticePeriod) {
        errors.noticePeriod = "Notice Period is required.";
    }

    return errors;
}


// Validation function for education and experience
export const validateEducationExperience = (formData) => {
    const errors = {
        education: [],
        experience: [],
    };

    // 🔹 Education validation
    formData.education.forEach((edu, idx) => {
        const eduErrors = {};
        if (!edu.qualification.trim()) eduErrors.qualification = "Qualification is required";
        if (!edu.university.trim()) eduErrors.university = "University is required";
        if (!edu.specialization.trim()) eduErrors.specialization = "Specialization is required";
        if (!edu.courseType.trim()) eduErrors.courseType = "Course type is required";
        if (!edu.startDate) eduErrors.startDate = "Start date is required";
        if (!edu.isPursuing && !edu.endDate) eduErrors.endDate = "End date is required if not pursuing";
        if (!edu.city && !edu.city) eduErrors.city = "City is required";
        errors.education[idx] = eduErrors;
    });

    // 🔹 Experience validation
    formData.experience.forEach((exp, idx) => {
        const expErrors = {};
        if (!exp.jobTitle.trim()) expErrors.jobTitle = "Job title is required";
        if (!exp.companyName.trim()) expErrors.companyName = "Company name is required";
        if (!exp.employmentType.trim()) expErrors.employmentType = "Employment type is required";
        if (!exp.industryType.trim()) expErrors.industryType = "Industry type is required";
        if (!exp.startDate) expErrors.startDate = "Start date is required";
        if (!exp.isWorking && !exp.endDate) expErrors.endDate = "End date is required if not working";
        if (!exp.noticePeriod.trim()) expErrors.noticePeriod = "Notice period is required";
        if (!exp.description.trim()) expErrors.description = "Description is required";
        errors.experience[idx] = expErrors;
    });

    return errors;
}

export const isValidAlphabeticString = (value) => {
    if (typeof value !== 'string') return false;

    const cleaned = value.toLowerCase().trim();

    const hasNumber = /\d/.test(cleaned);
    const isAlphabetOnly = /^[a-z\s]+$/.test(cleaned); // allows only letters and spaces

    return (!hasNumber && isAlphabetOnly) || false;
}


// ✅ Validation Function
export const validateFormDataSkills = (formData) => {
    const errors = {
        skills: [],
        primary: [],
        certification: [],
        projects: [],
        socialProfiles: [],
    };

    // Skills
    formData.skills.forEach((item, i) => {
        const obj = {};
        if (!item.skills.trim()) obj.skills = "skill is required";
        // if (!item.lastUsed.trim()) obj.lastUsed = "Last used is required";
        // if (!item.version.trim()) obj.version = "Version is required";

        // item.experience.forEach((exp, j) => {
        //   if (!exp.year.trim()) obj.year = "Year is required";
        //   if (!exp.month.trim()) obj.month = "Month is required";
        // });

        errors.skills[i] = obj;
    });

    // Primary
    formData.primary.forEach((item, i) => {
        const obj = {};
        if (!item.primarySkills.trim()) obj.primarySkills = "Primary skill is required";
        // if (!item.lastUsed.trim()) obj.lastUsed = "Last used is required";
        // if (!item.version.trim()) obj.version = "Version is required";

        // item.experience.forEach((exp, j) => {
        //   if (!exp.year.trim()) obj.year = "Year is required";
        //   if (!exp.month.trim()) obj.month = "Month is required";
        // });

        errors.primary[i] = obj;
    });

    // Certification
    formData.certification.forEach((item, i) => {
        const obj = {};
        if (!item.certificationName.trim()) obj.certificationName = "Certificate name is required";
        if (!item.organization.trim()) obj.organization = "Organization is required";
        if (!item.loaction.trim()) obj.location = "Location is required";
        // if (!item.issuedBy.trim()) obj.issuedBy = "Issued By is required";
        // if (!item.issuedDate.trim()) obj.issuedDate = "Issued Date is required";
        // if (!item.version.trim()) obj.version = "Version is required";
        errors.certification[i] = obj;
    });

    // projects
    formData.projects.forEach((item, i) => {
        const obj = {};
        if (!item.projectName.trim()) obj.projectName = "Project name is required";
        if (!item.portfolioUrl.trim()) obj.portfolioUrl = "URL is required";
        errors.portfolio[i] = obj;
    });

    // Social
    formData.socialProfiles.forEach((item, i) => {
        const obj = {};
        if (!item.name.trim()) obj.name = "Social profile is required";
        if (!item.url.trim()) obj.url = "URL is required";
        // if (!item.description.trim()) obj.description = "Description is required";
        errors.social[i] = obj;
    });

    return errors;
};



// Candidate Education validation
export const validateEducationInput = (topInput, setErrors) => {
    const newErrors = {};

    if (!topInput.institutionName?.toString().trim())
        newErrors.institutionName = "School / College name is required";

    if (!topInput.courseCategory?.toString().trim())
        newErrors.courseCategory = "Qualification is required";

    if (!topInput.courseType?.toString().trim())
        newErrors.courseType = "Course is required";


    if (!topInput.grade?.type || !topInput.grade.type.toString().trim())
        newErrors["grade.type"] = "Grade type is required";

    if (
        topInput.grade?.value === undefined ||
        topInput.grade.value === null ||
        topInput.grade.value.toString().trim() === ""
    ) {
        newErrors["grade.value"] = "Grade value is required";
    }

    if (topInput.zipCode && !(/^[0-9]{5,6}$/.test(topInput.zipCode))) {
        newErrors.zipCode = "Zip Code must be 5 or 6 digits";
    }
    else { newErrors.zipCode = "" }

    if (!topInput.city?.toString().trim())
        newErrors.city = "City is required";

    if (!topInput.mode?.toString().trim())
        newErrors.mode = "mode is required";

    if (!topInput.periodFrom?.[0]?.toString().trim())
        newErrors["periodFrom"] = "Year is required";

    if (!topInput.isOngoing && !topInput.periodTo?.[0]?.toString().trim())
        newErrors["periodTo"] = "Year is required";

    setErrors(newErrors);
    return Object.values(newErrors).filter(Boolean).length === 0;
};


export const validateCertificateInput = (topInput, setErrors, mandatory) => {
    const newErrors = {};
    if (!topInput || !topInput.certificationName?.trim()) {
        if (mandatory?.certificationName) {
            newErrors.certificationName = "Certificate name is required";
        }
    } else if (!/^[a-zA-Z0-9&/-\s]+$/.test(topInput.certificationName.trim())) {
        newErrors.certificationName = "Certificate name can only contain letters";
    }

    if (!topInput || !topInput.organization?.trim()) {
        newErrors.organization = "Organization is required";
    } else if (!/^[a-zA-Z0-9&/-\s]+$/.test(topInput.organization.trim())) {
        newErrors.organization = "Organization can only contain letters";
    }
    // Mode (online/offline)
    if (!topInput?.mode && mandatory?.mode) {
        newErrors.mode = "Mode is required";
    } else if (topInput?.mode && !["online", "offline"].includes(topInput.mode.toLowerCase())) {
        newErrors.mode = "Mode must be either 'online' or 'offline'";
    }
    if (topInput.link && topInput.link.trim()) {
        try {
            newErrors.link = URL(topInput.link);
        } catch (err) {
            // newErrors.link = "Link must be a valid URL";
        }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
}


export const CandidateProjectsvalidate = (topInput, setErrors, mandatory) => {
    const newErrors = {};

    if (!topInput?.projectName?.trim()) {
        if (mandatory.projectName) {
            newErrors.projectName = "Project name is required";
        }
    } else if (topInput.projectName.length < 3) {
        newErrors.projectName = "Project name must be at least 5 characters";
    } else if (!/^[a-zA-Z0-9&/-\s]+$/.test(topInput.projectName.trim())) {
        newErrors.projectName = "Project name can only contain letters";
    }

    if (!topInput.role.trim()) {
        if (mandatory.role) {
            newErrors.role = "Role is required";
        }
    }
    else if (topInput.role.trim().length < 3) {
        newErrors.role = "Role must be at least 3 characters";
    }
    else if (!/^[a-zA-Z0-9/-\s]+$/.test(topInput.role.trim())) {
        newErrors.role = "Role can only contain letters";
    }

    if (topInput?.clientName?.trim()) {
        const clientName = topInput.clientName.trim();
        if (clientName.length < 3) {
            newErrors.clientName = "Client name must be at least 3 characters";
        } else if (!/^[a-zA-Z\s]+$/.test(clientName)) {
            newErrors.clientName = "Client name can only contain letters and spaces";
        }
    }

    if (topInput?.location?.trim()) {
        const location = topInput.location.trim();

        if (location.length < 3) {
            newErrors.location = "Location must be at least 3 characters";
        } else if (!/^[a-zA-Z\s]+$/.test(location)) {
            newErrors.location = "Location can only contain letters and spaces";
        }
    }

    if (topInput?.description?.trim()) {
        const description = topInput.description.trim();

        if (description.length < 3) {
            newErrors.description = "Description must be at least 3 characters";
        } else if (!/^[a-zA-Z\s]+$/.test(description)) {
            newErrors.description = "Description can only contain letters and spaces";
        }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
};


export const Loginvalidator = (name, value) => {
    let error = "";
    if (name === "email") error = emailValidator(value);
    if (name === "password") error = passwordValidator(value);
    return error;
};

// validator.js
export const validateExperience = (topInput, setErrors, isFresher) => {
    const newErrors = {};
    if (!isFresher) {
        if (!topInput.jobTitle) newErrors.jobTitle = "Job Title is required";
        if (!topInput.employer) newErrors.employer = "Company Name is required";
        if (!topInput.employmentType) newErrors.employmentType = "Employment Type is required";
        if (!topInput.workMode) newErrors.workMode = "Work Mode is required";

        if (!topInput.industryType) newErrors.industryType = "Industry Type is required";

        if (topInput.isOngoing && !topInput.noticePeriod) newErrors.noticePeriod = "Notice Period is required";
        if (!topInput.city) newErrors.city = "City is required";
        if (!topInput.periodFrom || !topInput.periodFrom[0]) {
            newErrors.periodFromYear = "Start Year is required";
        }
        if (!topInput.isOngoing && (!topInput.periodTo || !topInput.periodTo[0])) {
            newErrors.periodToYear = "End Year is required";
        }
    }
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0;
};


// Validate only one field (onChange use pannunga)
// Validate single field (onChange)
export const validateSingleField = (field, value, mandatory = false) => {
    const patterns = {

        addressLine1: { regex: /^[A-Za-z0-9\s,.-]{3,100}$/, message: "Address Line 1 must be 3–100 characters (letters, numbers, space, , . - allowed)." },
        zipCode: { regex: /^[0-9]{5,6}$/, message: "Zip Code must be 5 or 6 digits." },
        state: { regex: /^[A-Za-z\s]{2,50}$/, message: "State must contain only letters and spaces (2–50 chars)." },
        country: { regex: /^[A-Za-z\s]{2,50}$/, message: "Country must contain only letters and spaces (2–50 chars)." },
    };

    if (mandatory && (!value || value.trim() === "")) {
        return `${field} is required.`;
    }

    if (patterns[field] && !patterns[field].regex.test(value)) {
        return patterns[field].message;
    }

    return ""; // no error
};

// Regex to check if the string contains only numeric values
export const isNumericString = (str) => {
    const regex = /^\d+$/;
    return regex.test(str);
}









